import { environmentConfig } from './EnvConfig';

/**
 * Get the project name
 * @returns The project name
 */
export const getProjectName = (): string => {
  return environmentConfig.PROJECT_NAME;
};

/**
 * Get the project version
 * @returns The project version
 */
export const getProjectVersion = (): string => {
  return environmentConfig.PROJECT_VERSION;
};

/**
 * Get the current environment name
 * @returns The current environment name (production, staging, development, or feature-*)
 */
export const getEnvironment = (): string => {
  if (!environmentConfig.ENV) {
    return 'production';
  }

  // if env includes '/' then replace it with '-'
  return environmentConfig.ENV.replace('/', '-');
};

/**
 * Check if the current environment is production
 * @returns True if the current environment is production, false otherwise
 */
export const isProduction = (): boolean => {
  return environmentConfig.ENV === 'production';
};

/**
 * Check if the current environment is sandbox
 * @returns True if the current environment is sandbox, false otherwise
 */
export const isSandbox = (): boolean => {
  return environmentConfig.ENV === 'sandbox';
};

/**
 * Get a resource name with environment suffix
 * @param baseName The base name of the resource
 * @returns The environment-specific resource name
 */
export const getResourceName = (baseName: string): string => {
  return `${getProjectName()}-${baseName}-${getEnvironment()}`;
};
